var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "customer-create main-content" },
    [
      _c("div", { staticClass: "page-header" }, [
        _c("h3", { staticClass: "page-title" }, [
          _vm._v(_vm._s(_vm.$t("invoices.attachments"))),
        ]),
        _vm._v(" "),
        _c("ol", { staticClass: "breadcrumb" }, [
          _c(
            "li",
            { staticClass: "breadcrumb-item" },
            [
              _vm.userType == "super_admin"
                ? _c(
                    "router-link",
                    {
                      attrs: {
                        slot: "item-title",
                        to: "/super-admin/dashboard",
                      },
                      slot: "item-title",
                    },
                    [_vm._v(_vm._s(_vm.$t("general.home")))]
                  )
                : _vm.userType == "supplier"
                ? _c(
                    "router-link",
                    {
                      attrs: { slot: "item-title", to: "/supplier/dashboard" },
                      slot: "item-title",
                    },
                    [_vm._v(_vm._s(_vm.$t("general.home")))]
                  )
                : _vm.userType == "anchor"
                ? _c(
                    "router-link",
                    {
                      attrs: { slot: "item-title", to: "/anchor/dashboard" },
                      slot: "item-title",
                    },
                    [_vm._v(_vm._s(_vm.$t("general.home")))]
                  )
                : _vm.userType == "funder"
                ? _c(
                    "router-link",
                    {
                      attrs: { slot: "item-title", to: "/funder/dashboard" },
                      slot: "item-title",
                    },
                    [_vm._v(_vm._s(_vm.$t("general.home")))]
                  )
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "li",
            { staticClass: "breadcrumb-item" },
            [
              _vm.userType == "super_admin"
                ? _c(
                    "router-link",
                    {
                      attrs: {
                        slot: "item-title",
                        to: "/super-admin/preapproved-invoices",
                      },
                      slot: "item-title",
                    },
                    [_vm._v(_vm._s(_vm.$tc("preapproved_invoices.invoice", 2)))]
                  )
                : _vm.userType == "supplier"
                ? _c(
                    "router-link",
                    {
                      attrs: {
                        slot: "item-title",
                        to: "/supplier/preapproved-invoices",
                      },
                      slot: "item-title",
                    },
                    [_vm._v(_vm._s(_vm.$tc("preapproved_invoices.invoice", 2)))]
                  )
                : _vm.userType == "anchor"
                ? _c(
                    "router-link",
                    {
                      attrs: {
                        slot: "item-title",
                        to: "/anchor/preapproved-invoices",
                      },
                      slot: "item-title",
                    },
                    [_vm._v(_vm._s(_vm.$tc("preapproved_invoices.invoice", 2)))]
                  )
                : _vm.userType == "funder"
                ? _c(
                    "router-link",
                    {
                      attrs: {
                        slot: "item-title",
                        to: "/funder/preapproved-invoices",
                      },
                      slot: "item-title",
                    },
                    [_vm._v(_vm._s(_vm.$tc("preapproved_invoices.invoice", 2)))]
                  )
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "li",
            { staticClass: "breadcrumb-item" },
            [
              _c(
                "router-link",
                { attrs: { slot: "item-title", to: "#" }, slot: "item-title" },
                [_vm._v(_vm._s(_vm.$tc("invoices.attachments", 2)))]
              ),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "page-actions row" }, [
          _vm.advanceOption &&
          _vm.invoiceStatus == "APPROVED" &&
          _vm.invoiceRequestLevel === "Eligible"
            ? _c(
                "div",
                { staticClass: "col-xs-2 mr-4" },
                [
                  _c(
                    "base-button",
                    {
                      attrs: { size: "large", icon: "plus", color: "theme" },
                      on: { click: _vm.addAttachment },
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$t("invoices.newAttachment")) +
                          "\n        "
                      ),
                    ]
                  ),
                ],
                1
              )
            : _vm._e(),
        ]),
      ]),
      _vm._v(" "),
      _c("SingleInvoiceRow", {
        attrs: { "fetch-data": _vm.fetchData, "table-div-id": _vm.tableDivId },
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.showEmptyScreen,
              expression: "showEmptyScreen",
            },
          ],
          staticClass: "col-xs-1 no-data-info",
          attrs: { align: "center" },
        },
        [
          _c("astronaut-icon", { staticClass: "mt-5 mb-4" }),
          _vm._v(" "),
          _c("div", { staticClass: "row", attrs: { align: "center" } }, [
            _c("label", { staticClass: "col title" }, [
              _vm._v(_vm._s(_vm.$t("invoices.no_attachments"))),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row" }, [
            _c(
              "label",
              {
                staticClass: "description col mt-1",
                attrs: { align: "center" },
              },
              [_vm._v(_vm._s(_vm.$t("invoices.list_of_attachments")))]
            ),
          ]),
          _vm._v(" "),
          _vm.advanceOption &&
          _vm.invoiceStatus == "APPROVED" &&
          _vm.invoiceRequestLevel === "Eligible"
            ? _c(
                "div",
                { staticClass: "btn-container" },
                [
                  _c(
                    "base-button",
                    {
                      staticClass: "mt-3",
                      attrs: { outline: true, color: "theme", size: "large" },
                      on: { click: _vm.addAttachment },
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.$t("invoices.add_new_attactment")) +
                          "\n      "
                      ),
                    ]
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.showEmptyScreen,
              expression: "!showEmptyScreen",
            },
          ],
          staticClass: "table-container",
        },
        [
          _c(
            "div",
            { staticClass: "table-actions mt-5" },
            [
              _c("p", { staticClass: "table-stats" }, [
                _vm._v(_vm._s(_vm.$t("general.showing")) + ": "),
                _c("b", [_vm._v(_vm._s(_vm.attachments.length))]),
              ]),
              _vm._v(" "),
              _c(
                "transition",
                { attrs: { name: "fade" } },
                [
                  _vm.selectedAttachments.length
                    ? _c(
                        "v-dropdown",
                        { attrs: { "show-arrow": false } },
                        [
                          _c(
                            "span",
                            {
                              staticClass:
                                "table-actions-button dropdown-toggle",
                              attrs: { slot: "activator", href: "#" },
                              slot: "activator",
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(_vm.$t("general.actions")) +
                                  "\n          "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _vm.advanceOption && _vm.invoiceStatus == "DRAFT"
                            ? _c("v-dropdown-item", [
                                _c(
                                  "div",
                                  {
                                    staticClass: "dropdown-item",
                                    on: {
                                      click: _vm.removeMultipleAttachments,
                                    },
                                  },
                                  [
                                    _c("font-awesome-icon", {
                                      staticClass: "dropdown-item-icon",
                                      attrs: { icon: ["fas", "trash"] },
                                    }),
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(_vm.$t("general.delete")) +
                                        "\n            "
                                    ),
                                  ],
                                  1
                                ),
                              ])
                            : _vm._e(),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "custom-control custom-checkbox" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.selectAllFieldStatus,
                  expression: "selectAllFieldStatus",
                },
              ],
              staticClass: "custom-control-input",
              attrs: { id: "select-all", type: "checkbox" },
              domProps: {
                checked: Array.isArray(_vm.selectAllFieldStatus)
                  ? _vm._i(_vm.selectAllFieldStatus, null) > -1
                  : _vm.selectAllFieldStatus,
              },
              on: {
                change: [
                  function ($event) {
                    var $$a = _vm.selectAllFieldStatus,
                      $$el = $event.target,
                      $$c = $$el.checked ? true : false
                    if (Array.isArray($$a)) {
                      var $$v = null,
                        $$i = _vm._i($$a, $$v)
                      if ($$el.checked) {
                        $$i < 0 &&
                          (_vm.selectAllFieldStatus = $$a.concat([$$v]))
                      } else {
                        $$i > -1 &&
                          (_vm.selectAllFieldStatus = $$a
                            .slice(0, $$i)
                            .concat($$a.slice($$i + 1)))
                      }
                    } else {
                      _vm.selectAllFieldStatus = $$c
                    }
                  },
                  _vm.selectAllAttachments,
                ],
              },
            }),
            _vm._v(" "),
            _c(
              "label",
              {
                staticClass: "custom-control-label selectall",
                attrs: { for: "select-all" },
              },
              [
                _c("span", { staticClass: "select-all-label" }, [
                  _vm._v(_vm._s(_vm.$t("general.select_all")) + " "),
                ]),
              ]
            ),
          ]),
          _vm._v(" "),
          _c(
            "table-component",
            {
              ref: "table",
              attrs: {
                "show-filter": false,
                data: _vm.attachments,
                "table-class": "table",
              },
            },
            [
              _c("table-column", {
                attrs: {
                  sortable: false,
                  filterable: false,
                  "cell-class": "no-click",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (row) {
                      return [
                        _c(
                          "div",
                          { staticClass: "custom-control custom-checkbox" },
                          [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.selectField,
                                  expression: "selectField",
                                },
                              ],
                              staticClass: "custom-control-input",
                              attrs: { id: row.id, type: "checkbox" },
                              domProps: {
                                value: row.id,
                                checked: Array.isArray(_vm.selectField)
                                  ? _vm._i(_vm.selectField, row.id) > -1
                                  : _vm.selectField,
                              },
                              on: {
                                change: function ($event) {
                                  var $$a = _vm.selectField,
                                    $$el = $event.target,
                                    $$c = $$el.checked ? true : false
                                  if (Array.isArray($$a)) {
                                    var $$v = row.id,
                                      $$i = _vm._i($$a, $$v)
                                    if ($$el.checked) {
                                      $$i < 0 &&
                                        (_vm.selectField = $$a.concat([$$v]))
                                    } else {
                                      $$i > -1 &&
                                        (_vm.selectField = $$a
                                          .slice(0, $$i)
                                          .concat($$a.slice($$i + 1)))
                                    }
                                  } else {
                                    _vm.selectField = $$c
                                  }
                                },
                              },
                            }),
                            _vm._v(" "),
                            _c("label", {
                              staticClass: "custom-control-label",
                              attrs: { for: row.id },
                            }),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("table-column", {
                attrs: {
                  label: _vm.$tc("documents.documentType", 1),
                  show: "documentType.name",
                },
              }),
              _vm._v(" "),
              _c("table-column", {
                attrs: { label: _vm.$t("documents.document"), show: "name" },
              }),
              _vm._v(" "),
              _c("table-column", {
                attrs: {
                  sortable: false,
                  filterable: false,
                  "cell-class": "action-dropdown",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (row) {
                      return [
                        _c("span", [
                          _vm._v(
                            " " + _vm._s(_vm.$t("customers.action")) + " "
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "v-dropdown",
                          [
                            _c(
                              "a",
                              {
                                attrs: { slot: "activator", href: "#" },
                                slot: "activator",
                              },
                              [_c("dot-icon")],
                              1
                            ),
                            _vm._v(" "),
                            _c("v-dropdown-item", [
                              _c("div", { staticClass: "dropdown-item" }, [
                                row.path
                                  ? _c(
                                      "a",
                                      {
                                        attrs: {
                                          href: row.path,
                                          target: "_blank",
                                        },
                                      },
                                      [
                                        _c("font-awesome-icon", {
                                          staticClass: "dropdown-item-icon",
                                          attrs: { icon: "eye" },
                                        }),
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(_vm.$t("general.view")) +
                                            "\n                "
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                              ]),
                            ]),
                            _vm._v(" "),
                            _vm.advanceOption &&
                            _vm.invoiceStatus == "APPROVED" &&
                            _vm.invoiceRequestLevel === "Eligible"
                              ? _c("v-dropdown-item", [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "dropdown-item",
                                      on: {
                                        click: function ($event) {
                                          return _vm.deleteDocument(row)
                                        },
                                      },
                                    },
                                    [
                                      _c("font-awesome-icon", {
                                        staticClass: "dropdown-item-icon",
                                        attrs: { icon: ["fas", "trash"] },
                                      }),
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(_vm.$t("general.delete")) +
                                          "\n              "
                                      ),
                                    ],
                                    1
                                  ),
                                ])
                              : _vm._e(),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }